import { Grid, Typography } from '@mui/material';
import images from 'assets/images';
import React from 'react';
import { Container } from '@mui/system';
import { otherFrameworksTimeLineObj } from 'assets/animation/portalAnimation';

const Frameworks: React.FC = () => {
    const otherFrameworksTimeLine = React.useRef(null);

    React.useEffect(() => {
        otherFrameworksTimeLineObj(otherFrameworksTimeLine);
    }, []);

    return (
        <section className="other-frameworks" ref={otherFrameworksTimeLine}>
            <Container maxWidth="lg">
                <Typography variant="body1" className="section-info">
                    We are compliant with Australian Digital Health Framework and accreditations.
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <div className="logo-block">
                            <a href="https://au.healthlink.net/" rel="noreferrer" target="_blank">
                                <img src={images.helthLinkLogoIcon} alt="Logo" />
                            </a>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <div className="logo-block">
                            <a href="https://www.commbank.com.au/" rel="noreferrer" target="_blank">
                                <img src={images.cmBankLogoIcon} alt="Logo" />
                            </a>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <div className="logo-block">
                            <a href="https://www.erx.com.au/" rel="noreferrer" target="_blank">
                                <img src={images.erxLogoIcon} alt="Logo" />
                            </a>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <div className="logo-block">
                            <a href="https://www.mims.com.au/" rel="noreferrer" target="_blank">
                                <img src={images.mimsLogoIcon} alt="Logo" />
                            </a>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <div className="logo-block">
                            <a href="https://www.servicesaustralia.gov.au/medicare" rel="noreferrer" target="_blank">
                                <img src={images.agmaLogoIcon} alt="Logo" />
                            </a>
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={4} lg={2}>
                        <div className="logo-block">
                            <a href="https://www.digitalhealth.gov.au/" rel="noreferrer" target="_blank">
                                <img src={images.agadLogoIcon} alt="Logo" />
                            </a>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </section>
    );
};

export default React.memo(Frameworks);
